import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { STORY_MODAL_NOTIFICATION_EVENT } from "./StoryModal.models";
export var StoryModalService = /*#__PURE__*/ function() {
    "use strict";
    function StoryModalService() {
        _class_call_check(this, StoryModalService);
    }
    var _proto = StoryModalService.prototype;
    _proto.handleShowStoryModal = function handleShowStoryModal(storyModalDetail) {
        var detail = _object_spread({}, storyModalDetail);
        this.storyModalEvent = new CustomEvent(STORY_MODAL_NOTIFICATION_EVENT, {
            detail: detail
        });
        document.dispatchEvent(this.storyModalEvent);
    };
    return StoryModalService;
}();
